import './VisuallyHidden.css';
export var visuallyHidden = '_1xz8nhz0-3-8-0';